// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__NM_nu","signatureButtonsRight":"ModalSign_signatureButtonsRight__2Vn3O"};